<div class="kpi">
  <div class="kpi__title">{{ scoreData()?.title }}</div>
  @if (loading()) {
  <div class="kpi__loader loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  }
  <div class="kpi__scores">
    <div class="kpi__score" [ngClass]="'kpi__score--' + scoreData()?.value">
      <div class="kpi__score-num">{{ scoreData()?.value }}</div>
      <div class="kpi__score-text">{{ scoreData()?.description }}</div>
    </div>
  </div>
</div>
